import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPin2"><Path d="M16.5 8.63477C18.6114 10.0737 20 12.4994 20 15.25V16H12.7529V20.25L12 22L11.25 20.25V16H4V15.25C4 12.4994 5.38861 10.0737 7.5 8.63477V2H16.5V8.63477Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPin2;
